module.exports = __webpack_public_path__ + "static/img/kftp2.6c64e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinus/kftp2.png
// module id = MLxL
// module chunks = 1